<template>
    <list-view class="custom-api-list-view">
        <template slot="filterContent">
            <veui-field v-if="hasWriteOpt">
                <veui-button ui="primary" @click="create">新建API</veui-button>
                <veui-button class="primary-border-btn"
                    @click="review"
                    :disabled="shouldDisableReview"
                >提交审核</veui-button>
            </veui-field>
            <veui-button v-if="showOffline" class="primary-border-btn" @click="offlineService">下线服务</veui-button>
        </template>
        <template slot="batchContent" v-if="isRejected && store.extra">
            <veui-span v-for="(reason, index) in store.extra.rejectReason" :key="index">{{reason}}</veui-span>
        </template>
        <template slot="tableColumns">
            <veui-table-column field="name" title="接口名">
                <template slot-scope="props"><p class="table-multi-line">{{ props.name }}</p></template>
            </veui-table-column>
            <veui-table-column field="protocol" title="协议">
                <template slot-scope="props">{{ store.protocolMap[props.protocol] }}</template>
            </veui-table-column>
            <veui-table-column field="requestMethod" title="请求">
                <template slot-scope="props">
                    <p class="table-multi-line">{{ store.methodMap[props.requestMethod] }}</p>
                </template>
            </veui-table-column>
            <veui-table-column field="operations" title="操作">
                <template slot-scope="props">
                    <veui-button ui="link" @click="detail(props.item.id)">查看</veui-button>
                    <veui-button ui="link" @click="edit(props.item.id)" v-if="hasWriteOpt">编辑</veui-button>
                    <veui-button ui="link" @click="remove(props.item.id)" v-if="hasWriteOpt">删除</veui-button>
                </template>
            </veui-table-column>
        </template>
    </list-view>
</template>

<script>
import ListView from '@baidu/ve-ria/views/ListView';
import ListModel from './ListModel';
import createView from '@baidu/ve-ria/views/createView';
import {Span, Button, Column, Field} from 'veui';
import autoSubmit from '@baidu/ve-ria/directives/autoSubmit';
import {includes, replace} from 'lodash';

export default createView(ListView, ListModel, {
    name: 'CustomApiListView',
    components: {
        'veui-table-column': Column,
        'veui-button': Button,
        'veui-span': Span,
        'veui-field': Field
    },
    directives: {
        autosubmit: autoSubmit
    },
    computed: {
        hasWriteOpt() {
            if (this.store.extra) {
                return includes(['REJECT', 'DRAFT', 'OFFLINE'], this.store.extra.serviceStatus);
            }
            return false;
        },
        showOffline() {
            return this.store.extra ? this.store.extra.serviceStatus === 'PUBLISHED' : false;
        },
        shouldDisableReview() {
            return this.store.totalCount <= 0;
        },
        isRejected() {
            if (this.store.extra) {
                return this.store.extra.serviceStatus === 'REJECT';
            }
            return false;
        }
    },
    methods: {
        create() {
            this.redirect('create');
        },
        detail(id) {
            this.redirect(`${id}/detail`);
        },
        edit(id) {
            this.redirect(`${id}/edit`);
        },
        async remove(id) {
            let res = await this.waitConfirm('是否删除API数据？', '温馨提示');
            if (res) {
                await this.store.deleteApi(id);
                this.showToast('删除API成功！', {type: 'success'});
                this.store.requestList();
            }
        },
        async offlineService() {
            await this.store.offlineServiceRequester({id: this.store.filter.serviceId});
            this.showToast('下线成功', {type: 'success'});
            this.store.requestList();
        },
        async review() {
            await this.store.reviewService();
            this.showToast('提交审核成功！', {type: 'success'});
            this.store.requestList();
        },
        redirect(postfix) {
            let routePath = this.store.getRoutePath();
            this.global.redirect({
                type: 'push',
                url: replace(routePath, 'list', postfix)
            });
        }
    }
});
</script>

<style lang="less">
@import '~veui-theme-one/variables.less';

.custom-api-list-view {
    .list-batch {
        margin-top: 20px;

        .veui-span {
            display: block;
            line-height: @veui-height-tiny;
        }
    }
}
</style>
